import { _ as _slicedToArray } from './slicedToArray-26803f33.js';
import { _ as _asyncToGenerator, r as regenerator } from './index-6bb2031f.js';
import { _ as _defineProperty } from './defineProperty-18999f8e.js';
import { c as _inherits, d as _getPrototypeOf, e as _possibleConstructorReturn, a as _classCallCheck, _ as _createClass, a1 as createImage, a2 as _get, t as drawNode, a3 as getNodeLayer, s as setNodeAttrs } from './selectors-f64b5778.js';
import { _ as _arrayMap, a as _arrayIncludes, b as _arrayIncludesWith, i as isArrayLikeObject_1, c as _baseRest, B as BaseLayer } from './base-a1755813.js';
import { _ as _SetCache, a as _baseUnary, b as _cacheHas } from './isEqual-347ac7db.js';
import loadingImage from './utils/loadingImage/index.js';
import { K as KnownErrors } from './common-94559169.js';
import { PRIORITY } from './configs/index.js';
import callbacksResolver from './utils/callbacksResolver/index.js';
import imageReadyResolver from './utils/imageReadyResolver/index.js';
import getImageLayerDefaultAttrs from './defaults/image/index.js';
import { getLayerManipulations } from './external/index.js';
import { cache, createCanvas, detectCanvasMaxArea, getImage, getScale, getLimitSize } from './layers/image/utils/index/index.js';
import { clearCache } from '@pa/editor-lib';
import applyMask from './layers/image/utils/applyMask/index.js';
import applyAdjust from './layers/image/utils/applyAdjust/index.js';
import applyEffect from './layers/image/utils/applyEffect/index.js';
import applyOriginalImageChanges from './layers/image/utils/applyOriginalImageChanges/index.js';

var SetCache = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    arrayMap$1 = _arrayMap,
    baseUnary = _baseUnary,
    cacheHas = _cacheHas;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */

function baseIntersection$1(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];

    if (othIndex && iteratee) {
      array = arrayMap$1(array, baseUnary(iteratee));
    }

    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
  }

  array = arrays[0];
  var index = -1,
      seen = caches[0];

  outer: while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;

    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
      othIndex = othLength;

      while (--othIndex) {
        var cache = caches[othIndex];

        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
          continue outer;
        }
      }

      if (seen) {
        seen.push(computed);
      }

      result.push(value);
    }
  }

  return result;
}

var _baseIntersection = baseIntersection$1;

var isArrayLikeObject = isArrayLikeObject_1;
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */

function castArrayLikeObject$1(value) {
  return isArrayLikeObject(value) ? value : [];
}

var _castArrayLikeObject = castArrayLikeObject$1;

var arrayMap = _arrayMap,
    baseIntersection = _baseIntersection,
    baseRest = _baseRest,
    castArrayLikeObject = _castArrayLikeObject;
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */

var intersection = baseRest(function (arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
var intersection_1 = intersection;

var pipeline = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(resolver, reject, _ref, _ref2) {
    var id, ctx, image, width, height, cached_eiImageEffect, cached_originalImage, cached_eiImageEAdjust, _ref2$isOriginalImage, isOriginalImageChange, _ref2$isEffectChange, isEffectChange, _ref2$isMaskOrAdjustC, isMaskOrAdjustChange, _ref2$isMaskChange, isMaskChange, result, _getLayerManipulation, logger, isImageChanged, isImageOrEffectChanged, isArtefactChanged, originalImage, effect, adjust, maskImage, effectResult, adjustResult;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id, ctx = _ref.ctx, image = _ref.image, width = _ref.width, height = _ref.height, cached_eiImageEffect = _ref.cached_eiImageEffect, cached_originalImage = _ref.cached_originalImage, cached_eiImageEAdjust = _ref.cached_eiImageEAdjust;
            _ref2$isOriginalImage = _ref2.isOriginalImageChange, isOriginalImageChange = _ref2$isOriginalImage === void 0 ? false : _ref2$isOriginalImage, _ref2$isEffectChange = _ref2.isEffectChange, isEffectChange = _ref2$isEffectChange === void 0 ? false : _ref2$isEffectChange, _ref2$isMaskOrAdjustC = _ref2.isMaskOrAdjustChange, isMaskOrAdjustChange = _ref2$isMaskOrAdjustC === void 0 ? false : _ref2$isMaskOrAdjustC, _ref2$isMaskChange = _ref2.isMaskChange, isMaskChange = _ref2$isMaskChange === void 0 ? false : _ref2$isMaskChange;
            result = new ImageData(1, 1);
            _getLayerManipulation = getLayerManipulations(), logger = _getLayerManipulation.logger;
            isImageChanged = isOriginalImageChange || !cached_originalImage;
            isImageOrEffectChanged = isImageChanged || isEffectChange;
            isArtefactChanged = isImageOrEffectChanged || isMaskOrAdjustChange;
            originalImage = image.originalImage, effect = image.effect, adjust = image.adjust, maskImage = image.maskImage; // originalImage pipe

            try {
              result = isImageChanged ? cache[id].cached_originalImage = applyOriginalImageChanges(originalImage, width, height) : cached_originalImage;
              isOriginalImageChange && clearCache(id);
            } catch (err) {
              logger(err, 'error');
            } // >>>>>>>>>> Apply EFFECT pipe <<<<<<<<<


            _context.prev = 9;

            if (!isImageOrEffectChanged) {
              _context.next = 20;
              break;
            }

            _context.next = 13;
            return applyEffect(id, result, effect);

          case 13:
            effectResult = _context.sent;

            if (cache[id]) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", reject(KnownErrors.removedImage));

          case 16:
            cache[id].cached_eiImageEffect = effectResult;
            result = effectResult;
            _context.next = 21;
            break;

          case 20:
            if (cached_eiImageEffect) {
              result = cached_eiImageEffect;
            }

          case 21:
            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](9);
            logger(_context.t0, 'error');

          case 26:
            _context.prev = 26;

            if (!isArtefactChanged) {
              _context.next = 37;
              break;
            }

            _context.next = 30;
            return applyAdjust(result, adjust);

          case 30:
            adjustResult = _context.sent;

            if (cache[id]) {
              _context.next = 33;
              break;
            }

            return _context.abrupt("return", reject(KnownErrors.removedImage));

          case 33:
            cache[id].cached_eiImageEAdjust = adjustResult;
            result = adjustResult;
            _context.next = 38;
            break;

          case 37:
            if (cached_eiImageEAdjust) {
              result = cached_eiImageEAdjust;
            }

          case 38:
            _context.next = 43;
            break;

          case 40:
            _context.prev = 40;
            _context.t1 = _context["catch"](26);
            logger(_context.t1, 'error');

          case 43:
            // Update and draw Image
            ctx.canvas.width = result.width;
            ctx.canvas.height = result.height;
            ctx.putImageData(result, 0, 0); // >>>>>>>>>>  Apply MASK pipe <<<<<<<<<

            if (maskImage && (isArtefactChanged || isMaskChange)) {
              applyMask(ctx, maskImage);
            }

            resolver(ctx.canvas);

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 23], [26, 40]]);
  }));

  return function pipeline(_x, _x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

function runImagePipeline(_x, _x2, _x3) {
  return _runImagePipeline.apply(this, arguments);
}

function _runImagePipeline() {
  _runImagePipeline = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(_ref, _ref2, image) {
    var _lastPromise$reject;

    var width,
        height,
        maximumPixels,
        _ref2$isOriginalImage,
        isOriginalImageChange,
        _ref2$isEffectChange,
        isEffectChange,
        _ref2$isEffectMaskCha,
        isEffectMaskChange,
        _ref2$isAdjustChange,
        isAdjustChange,
        _ref2$isMaskChange,
        isMaskChange,
        _ref2$isBlendChangeWi,
        isBlendChangeWithEffect,
        priority,
        id,
        _ref3,
        ctxWidth,
        ctxHeight,
        _cache$id,
        _cache$id$ctx,
        ctx,
        cached_eiImageEffect,
        cached_eiImageEAdjust,
        cached_originalImage,
        lastRequestIdleCallbackId,
        _cache$id$lastPromise,
        lastPromise,
        isMaskOrAdjustChange,
        defer,
        pipeCall,
        _args = arguments;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            width = _ref.width, height = _ref.height, maximumPixels = _ref.maximumPixels;
            _ref2$isOriginalImage = _ref2.isOriginalImageChange, isOriginalImageChange = _ref2$isOriginalImage === void 0 ? false : _ref2$isOriginalImage, _ref2$isEffectChange = _ref2.isEffectChange, isEffectChange = _ref2$isEffectChange === void 0 ? false : _ref2$isEffectChange, _ref2$isEffectMaskCha = _ref2.isEffectMaskChange, isEffectMaskChange = _ref2$isEffectMaskCha === void 0 ? false : _ref2$isEffectMaskCha, _ref2$isAdjustChange = _ref2.isAdjustChange, isAdjustChange = _ref2$isAdjustChange === void 0 ? false : _ref2$isAdjustChange, _ref2$isMaskChange = _ref2.isMaskChange, isMaskChange = _ref2$isMaskChange === void 0 ? false : _ref2$isMaskChange, _ref2$isBlendChangeWi = _ref2.isBlendChangeWithEffect, isBlendChangeWithEffect = _ref2$isBlendChangeWi === void 0 ? false : _ref2$isBlendChangeWi;
            priority = _args.length > 3 && _args[3] !== undefined ? _args[3] : PRIORITY.low;
            id = image.id;
            _ref3 = image.originalImage instanceof HTMLCanvasElement ? {
              ctxWidth: image.originalImage.width,
              ctxHeight: image.originalImage.height
            } : {
              ctxWidth: width,
              ctxHeight: height
            }, ctxWidth = _ref3.ctxWidth, ctxHeight = _ref3.ctxHeight;
            _cache$id = cache[id];
            _cache$id = _cache$id === void 0 ? {} : _cache$id;
            _cache$id$ctx = _cache$id.ctx, ctx = _cache$id$ctx === void 0 ? createCanvas(id, ctxWidth, ctxHeight, maximumPixels) : _cache$id$ctx, cached_eiImageEffect = _cache$id.cached_eiImageEffect, cached_eiImageEAdjust = _cache$id.cached_eiImageEAdjust, cached_originalImage = _cache$id.cached_originalImage, lastRequestIdleCallbackId = _cache$id.lastRequestIdleCallbackId, _cache$id$lastPromise = _cache$id.lastPromise, lastPromise = _cache$id$lastPromise === void 0 ? {} : _cache$id$lastPromise;
            isMaskOrAdjustChange = isEffectMaskChange || isAdjustChange;

            if (lastPromise.changeItems) {
              /* eslint-disable no-param-reassign */
              isOriginalImageChange = isOriginalImageChange || lastPromise.changeItems.isOriginalImageChange;
              isEffectChange = isEffectChange || lastPromise.changeItems.isEffectChange;
              isEffectMaskChange = isEffectMaskChange || lastPromise.changeItems.isEffectMaskChange;
              isAdjustChange = isAdjustChange || lastPromise.changeItems.isAdjustChange;
              isMaskChange = isMaskChange || lastPromise.changeItems.isMaskChange;
              isBlendChangeWithEffect = isBlendChangeWithEffect || lastPromise.changeItems.isBlendChangeWithEffect;
              /* eslint-enable no-param-reassign */
            }

            window.cancelIdleCallback(lastRequestIdleCallbackId || 0);
            lastPromise === null || lastPromise === void 0 ? void 0 : (_lastPromise$reject = lastPromise.reject) === null || _lastPromise$reject === void 0 ? void 0 : _lastPromise$reject.call(lastPromise, KnownErrors.cancelPipeline); // NOTE prev canceled task have isEffectChange = true but current task have isEffectChange = false
            // mentioned above case come to bug (PW-23820) effects not apply
            // in order to get prev task change items I store it in cache too

            defer = {
              changeItems: {
                isOriginalImageChange: isOriginalImageChange,
                isEffectChange: isEffectChange,
                isEffectMaskChange: isEffectMaskChange,
                isAdjustChange: isAdjustChange,
                isMaskChange: isMaskChange,
                isBlendChangeWithEffect: isBlendChangeWithEffect
              }
            };
            defer.promise = new Promise(function (resolve, reject) {
              defer.resolve = function () {
                defer.changeItems = null;
                resolve.apply(void 0, arguments);
              };

              defer.reject = function () {
                defer.changeItems = null; // eslint-disable-next-line prefer-promise-reject-errors

                reject.apply(void 0, arguments);
              };
            });
            cache[id].lastPromise = defer;

            pipeCall = function pipeCall() {
              return pipeline(defer.resolve, defer.reject, {
                ctx: ctx,
                id: id,
                image: image,
                width: ctxWidth,
                height: ctxHeight,
                cached_eiImageEffect: cached_eiImageEffect,
                cached_originalImage: cached_originalImage,
                cached_eiImageEAdjust: cached_eiImageEAdjust
              }, {
                isOriginalImageChange: isOriginalImageChange,
                isEffectChange: isEffectChange,
                isMaskOrAdjustChange: isMaskOrAdjustChange,
                isMaskChange: isMaskChange
              });
            };

            if (priority === PRIORITY.low) {
              cache[id].lastRequestIdleCallbackId = window.requestIdleCallback(pipeCall);
            } else {
              pipeCall();
            }

            return _context.abrupt("return", defer.promise);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _runImagePipeline.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ImageLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(ImageLayer, _BaseLayer);

  var _super = _createSuper(ImageLayer);

  function ImageLayer(partialArgs) {
    var _this;

    _classCallCheck(this, ImageLayer);

    var args = _objectSpread(_objectSpread({}, getImageLayerDefaultAttrs()), partialArgs);

    _this = _super.call(this, args, ['url', 'effect', 'adjust', 'maskUrl', 'priorityOnUpdate']);
    var url = args.url,
        image = args.image,
        maskUrl = args.maskUrl,
        maskImage = args.maskImage,
        adjust = args.adjust,
        effect = args.effect,
        visible = args.visible,
        priorityOnUpdate = args.priorityOnUpdate;
    _this.adjust = adjust;
    _this.meta.adjustGroups = {
      light: true
    };
    _this.effect = effect;
    _this.priorityOnUpdate = priorityOnUpdate || PRIORITY.low;

    if (maskImage) {
      _this.maskUrl = maskImage.src;
      _this.maskImage = maskImage;
    } else if (maskUrl) {
      _this.maskImage = new Image();
      _this.maskImage.crossOrigin = 'anonymous';
      _this.maskImage.src = maskUrl;
      _this.maskUrl = maskUrl;
    }

    if (image instanceof HTMLImageElement) {
      image.crossOrigin = 'anonymous';

      if (!image.src) {
        if (url) {
          image.src = url;
        } else {
          getLayerManipulations().logger('You should provide either url or image to create ImageLayer', 'error');
        }
      }

      _this.url = image.src;
      _this.handler = getLayerManipulations().addHandlerOnZoomChange( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(keys) {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.updateRenderable(keys);

                case 2:
                  _this.renderable && drawNode(getNodeLayer(_this.renderable));

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    _this.originalImage = image;
    _this.image = image;
    _this.visible = visible;
    _this.oldWidth = _this.width;
    _this.oldHeight = _this.height;
    _this.maximumPixels = detectCanvasMaxArea();

    _this.generate(image);

    return _this;
  }

  _createClass(ImageLayer, [{
    key: "readyHelper",
    value: function readyHelper() {
      this.readyToRender = true;
      this.visible = true;
      this.eventTarget.dispatchEvent(this.readyEvent);
    }
  }, {
    key: "generateRenderable",
    value: function generateRenderable() {
      var _this2 = this;

      this.innerRenderable = createImage({
        x: this.x,
        y: this.y,
        id: this.id,
        width: this.width,
        image: this.image,
        height: this.height,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        zIndex: this.zIndex,
        opacity: this.opacity,
        visible: this.visible,
        rotation: this.rotation,
        draggable: this.draggable,
        listening: this.interactable,
        globalCompositeOperation: this.globalCompositeOperation
      });

      var _callbacksResolver = callbacksResolver( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return runImagePipeline({
                  width: _this2.oldWidth,
                  height: _this2.oldHeight,
                  maximumPixels: _this2.maximumPixels
                }, {
                  isOriginalImageChange: true,
                  isEffectChange: true,
                  isEffectMaskChange: true,
                  isAdjustChange: true,
                  isMaskChange: true,
                  isBlendChangeWithEffect: false
                }, _this2, PRIORITY.high);

              case 3:
                _this2.image = _context2.sent;

                _this2.innerRenderable.image(_this2.image);

                _this2.readyHelper();

                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                if (!(_context2.t0 in KnownErrors)) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return");

              case 12:
                getLayerManipulations().logger("generate: ".concat(_context2.t0), 'error');

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      })), 2),
          _callbacksResolver2 = _slicedToArray(_callbacksResolver, 2),
          maskReady = _callbacksResolver2[0],
          imageReady = _callbacksResolver2[1];

      if (this.maskImage instanceof HTMLImageElement) {
        imageReadyResolver(this.maskImage, maskReady);
      } else {
        maskReady();
      }

      if (this.originalImage instanceof HTMLImageElement) {
        imageReadyResolver(this.originalImage, imageReady);
      } else {
        imageReady();
      }
    } // NOTE: Don't use this function, it should be deleted

  }, {
    key: "getImage",
    value: function () {
      var _getImage2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(skipSteps, size) {
        var image;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getImage(skipSteps, this, size);

              case 2:
                image = _context3.sent;
                return _context3.abrupt("return", image);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getImage$1(_x2, _x3) {
        return _getImage2.apply(this, arguments);
      }

      return getImage$1;
    }()
  }, {
    key: "shouldDimensionUpdate",
    value: function shouldDimensionUpdate(_ref3) {
      var width = _ref3.width,
          height = _ref3.height;
      if (width === 0 || height === 0 || width === this.oldWidth && height === this.oldHeight) return false;
      if (width !== this.oldWidth) this.oldWidth = width;
      if (height !== this.oldHeight) this.oldHeight = height;
      return true;
    }
  }, {
    key: "updateRenderable",
    value: function () {
      var _updateRenderable = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(updatedKeys) {
        var urlChanged, effectChanged, adjustChanged, maskUrlChanged, dimensionChanged, url, updateDimension, zoom, _ref4, ogWidth, ogHeight, calcWidth, calcHeight, _getLimitSize, width, height;

        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.readyToRender) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                urlChanged = updatedKeys.includes('url');
                effectChanged = updatedKeys.includes('effect');
                adjustChanged = updatedKeys.includes('adjust');
                maskUrlChanged = updatedKeys.includes('maskUrl');
                dimensionChanged = !!(this.url && intersection_1(updatedKeys, ['zoom']).length) || urlChanged; // Temporary disabled, will be enabled in Q3-Q4
                // const blendChange = !!(this.effect?.name && updatedKeys.includes('globalCompositeOperation'));

                url = this.url;

                if (!urlChanged) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 11;
                return loadingImage(url);

              case 11:
                this.originalImage = _context4.sent;

              case 12:
                if (!maskUrlChanged) {
                  _context4.next = 21;
                  break;
                }

                if (!this.maskUrl) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 16;
                return loadingImage(this.maskUrl);

              case 16:
                _context4.t0 = _context4.sent;
                _context4.next = 20;
                break;

              case 19:
                _context4.t0 = undefined;

              case 20:
                this.maskImage = _context4.t0;

              case 21:
                updateDimension = false;

                if (dimensionChanged) {
                  zoom = getLayerManipulations().getInMemoryZoom();
                  _ref4 = this.originalImage, ogWidth = _ref4.width, ogHeight = _ref4.height;
                  calcWidth = Math.ceil(ogWidth * getScale(this.scaleX, zoom));
                  calcHeight = Math.ceil(ogHeight * getScale(this.scaleY, zoom));
                  _getLimitSize = getLimitSize({
                    width: Math.min(ogWidth, calcWidth),
                    height: Math.min(ogHeight, calcHeight),
                    maximumPixels: this.maximumPixels
                  }), width = _getLimitSize.width, height = _getLimitSize.height;
                  updateDimension = this.shouldDimensionUpdate({
                    width: width,
                    height: height
                  });
                }

                if (!(urlChanged || effectChanged || adjustChanged || maskUrlChanged || updateDimension)) {
                  _context4.next = 37;
                  break;
                }

                _context4.prev = 24;
                _context4.next = 27;
                return runImagePipeline({
                  width: this.oldWidth,
                  height: this.oldHeight,
                  maximumPixels: this.maximumPixels
                }, {
                  isOriginalImageChange: urlChanged || updateDimension,
                  isEffectChange: effectChanged,
                  isEffectMaskChange: false,
                  isAdjustChange: adjustChanged,
                  isMaskChange: maskUrlChanged,
                  isBlendChangeWithEffect: false
                }, this, this.priorityOnUpdate);

              case 27:
                this.image = _context4.sent;
                this.innerRenderable.image(this.image);
                this.priorityOnUpdate = PRIORITY.low;
                _context4.next = 37;
                break;

              case 32:
                _context4.prev = 32;
                _context4.t1 = _context4["catch"](24);

                if (!(_context4.t1 in KnownErrors)) {
                  _context4.next = 36;
                  break;
                }

                return _context4.abrupt("return");

              case 36:
                getLayerManipulations().logger("update: ".concat(_context4.t1), 'error');

              case 37:
                setNodeAttrs(this.innerRenderable, {
                  width: this.width,
                  height: this.height,
                  opacity: this.opacity,
                  globalCompositeOperation: this.globalCompositeOperation
                });

              case 38:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[24, 32]]);
      }));

      function updateRenderable(_x4) {
        return _updateRenderable.apply(this, arguments);
      }

      return updateRenderable;
    }()
  }, {
    key: "clearCache",
    value: function clearCache() {
      var _this$handler;

      _get(_getPrototypeOf(ImageLayer.prototype), "clearCache", this).call(this);

      delete cache[this.id]; // cleanup

      (_this$handler = this.handler) === null || _this$handler === void 0 ? void 0 : _this$handler.call(this);
    }
  }, {
    key: "applyMutations",
    value: function applyMutations() {
      this.originalImage = this.image;
      return this.originalImage instanceof Image ? this.originalImage.src : this.url;
    }
  }]);

  return ImageLayer;
}(BaseLayer);

var getImageLayerResources = function getImageLayerResources(layerProvider, provider, layerId) {
  var layer = layerProvider.getLayer(layerId);

  if (layer instanceof ImageLayer) {
    return {
      image: layer.image,
      getImage: layer.getImage.bind(layer),
      get_image: function get_image() {
        return layer.innerRenderable.image();
      },
      set_image: function set_image(image) {
        layer.innerRenderable.image(image);
        drawNode(provider.layer);
      },
      maskImage: layer.maskImage,
      maskUrl: layer.maskUrl
    };
  }
};

export { ImageLayer as I, getImageLayerResources as g, intersection_1 as i };
